/**
 * Query class to get values from the URL query.
 *
 */

export class Query {
  constructor() {
    let queryStart = window.location.href.indexOf("?");
    this.parameters = null;

    if (queryStart >= 0) {
      let query = window.location.href.substr(queryStart + 1);
      if (query.length > 0) {
        let parameters = query.split("&");

        if (parameters.length > 0) {
          this.parameters = parameters.map((parameter) => {
            let pair = parameter.split("=");

            if (pair.length > 1) {
              return { name: pair[0].toLowerCase(), value: pair[1] };
            }
            return { name: pair[0].toLowerCase(), value: true };
          });
        }
      }
    }
  }

  /**
   *  Get a value.
   * @param {string} name
   * @returns string value
   */
  get(name) {
    if (this.parameters && this.parameters.length > 0) {
      let pair = this.parameters.find((p) => {
        return p.name === name;
      });

      if (!pair) {
        return null;
      }
      return pair.value;
    }
  }
}
